import { lazy } from 'react';
import type { RouteProps } from 'react-router-dom';

const DeveloperGuide = lazy(() => import('./index'));

/** 路由配置 */
export const routeConfig: RouteProps[] = [
  {
    path: '/developer-guide',
    element: <DeveloperGuide />,
  },
];
